import { render } from "./CustomizedSize.vue?vue&type=template&id=4ce35a77&ts=true"
import script from "./CustomizedSize.vue?vue&type=script&lang=ts"
export * from "./CustomizedSize.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__